import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { PUBLIC } from 'router/constants/routes';

import { selectGuidesInfo } from 'store/guides/selectors';
import { logout } from 'store/auth/actions';

import { sendAnalyticSideBarLogoutClick } from 'services/analytics';

import { useSidebarControl } from 'hooks';

import { getPrimarySidebarLinks, useGetSecondarySidebarLinks } from './helpers';

import { Text } from 'components/library';
import SidebarLink from './components/SidebarLink';

import * as S from './styled';

import { linkType } from './types';
import { useHandleContactRequest } from 'hooks/common/useHandleContactRequest';

function SideBar() {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const sidebarLinks = useGetSecondarySidebarLinks();
    const { onClick, isLoading } = useHandleContactRequest();

    const { isOpen, close } = useSidebarControl();
    const { isShowGuidesNotification } = useSelector(selectGuidesInfo);

    const navigate = useNavigate();

    const handleLogout = () => {
        sendAnalyticSideBarLogoutClick();

        dispatch(logout());

        navigate(PUBLIC.LOGIN.path);

        close();
    };

    return (
        <S.SideBarWrapper $isOpen={isOpen}>
            <S.SideBarOverlay onClick={close} />
            <S.SideBarMenu>
                {getPrimarySidebarLinks({ isShowGuidesNotification: Boolean(isShowGuidesNotification) }).map(
                    ({ ...props }, index) => (
                        <SidebarLink key={index} onClick={close} type={linkType.Primary} {...props} />
                    )
                )}

                <S.Hr />

                {sidebarLinks.map(({ ...props }, index) => (
                    <SidebarLink key={index} onClick={close} type={linkType.Secondary} {...props} />
                ))}

                <S.NavButton disabled={isLoading} $isLoading={isLoading} onClick={onClick} data-locator="contactUsLink">
                    <Text type="medium-text" color="text-secondary">
                        {t('basics.contactUs')}
                    </Text>
                </S.NavButton>

                <S.NavButton onClick={handleLogout} data-locator="burgerLogoutBtn">
                    <Text type="medium-text" color="text-secondary">
                        {t('sidebar.logout')}
                    </Text>
                </S.NavButton>

                <S.Hr />
            </S.SideBarMenu>
        </S.SideBarWrapper>
    );
}

export default SideBar;
